module.exports = __webpack_public_path__ + "static/qsg-docs-icon-d4c0d22d76592e1776fe89cb11df61aa.svg";